import React, {Component} from "react";
import {connect} from "react-redux";
import ActionButton from "../../components/ActionButton";
import PanelGroupController from "../../components/PanelGroupController";
import PanelHeaderItem from "../../components/PanelHeaderItem";
import DeliveryInfoPanel from "../../subscriptions/panels/DeliveryInfoPanel";
import DeliveryLogPanel from "../../subscriptions/panels/DeliveryLogPanel";
import * as SubscriptionApiActions from "../../actions/SubscriptionApiActions";
import {List} from "immutable";
import "./SubscriptionDeliveryView.css";

class SubscriptionDeliveryView extends Component {

  constructor(props) {
    super(props);
    this.handlePanelItemSelection = this.handlePanelItemSelection.bind(this);
    this.state = {
      selectedPanelId: "properties"
    }
  }

  render() {
    let panels = this.renderPanels();
    return (
      <div className="SubscriptionDeliveryView">
        <div className="PanelContainer">
          <div className="header">
            <PanelHeaderItem label="Properties" id="properties" selectedId={this.state.selectedPanelId} onClick={this.handlePanelItemSelection} />
            <PanelHeaderItem label="Log" id="log" selectedId={this.state.selectedPanelId} onClick={this.handlePanelItemSelection} />
          </div>
          {panels}
          <PanelGroupController title="Actions">
            <ActionButton 
              label="Manually Start Delivery" 
              onClick={this.handleStartDelivery.bind(this)} />          
            <ActionButton 
              label="Retry Stock Reservation" 
              onClick={this.handleRetryStockReservation.bind(this)} />          
            <ActionButton 
              label="Change Stock Reservation Warehouse" 
              onClick={this.handleChangeStockReservationWarehouse.bind(this)} />          
            <ActionButton 
              label="Retry Scheduling" 
              onClick={this.handleRetryScheduling.bind(this)} />          
          </PanelGroupController>          
        </div>
      </div>
    )
  }

  renderPanels() {
    if (this.state.selectedPanelId === "properties") {
      return this.buildPanels(List([DeliveryInfoPanel]));
    } else if (this.state.selectedPanelId === "log") {
      return this.buildPanels(List([DeliveryLogPanel]));
    } else {
      return null;
    }
  }

  buildPanels(panels) {
    return panels.map(x => this.buildPanel(x));
  }

  buildPanel(component) {
    switch(component) {

      case DeliveryInfoPanel:
        return <DeliveryInfoPanel key="DeliveryInfoPanel" deliveryId={this.props.deliveryId} />

      case DeliveryLogPanel:
        return <DeliveryLogPanel key="DeliveryLogPanel" deliveryId={this.props.deliveryId} />

      default:
        return null;      
    }
  } 


  handlePanelItemSelection(id) {
    this.setState({selectedPanelId: id});
  }    

  handleStartDelivery() {
    this.props.requestStartDelivery(this.props.deliveryId);
  }

  handleRetryScheduling() {
    this.props.requestRetryScheduling(this.props.deliveryId);
  }

  handleRetryStockReservation() {
    this.props.requestRetryStockReservation(this.props.deliveryId);
  }  

  handleChangeStockReservationWarehouse() {
    this.props.requestChangeStockReservationWarehouse(this.props.deliveryId);
  }  

}

export default connect(null, {...SubscriptionApiActions})(SubscriptionDeliveryView);